const DEMO_PRODUCT = {
  id: 88888888,
  title: 'Vincent leather jacket',
  handle: 'vincent-leather-jacket',
  price: 18500,
  compare_at_price: null,
  available: true,
  images: [
    'https://images.unsplash.com/photo-1551028719-00167b16eac5?q=80&w=1000&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1520975916090-3105956dac38?q=80&w=1000&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1544441893-675973e31985?q=80&w=1000&auto=format&fit=crop'
  ],
  featured_image: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?q=80&w=1000&auto=format&fit=crop',
  options: [
    {
      name: 'Color',
      position: 1,
      values: ['Brown', 'Black', 'Tan']
    },
    {
      name: 'Size',
      position: 2,
      values: ['S', 'M', 'L', 'XL']
    }
  ],
  variants: [
    {
      id: 1001,
      title: 'Brown / S',
      price: 18500,
      available: true,
      options: ['Brown', 'S'],
      featured_image: { src: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?q=80&w=1000&auto=format&fit=crop' }
    },
    {
      id: 1002,
      title: 'Brown / M',
      price: 18500,
      available: true,
      options: ['Brown', 'M'],
      featured_image: { src: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?q=80&w=1000&auto=format&fit=crop' }
    },
    {
      id: 1003,
      title: 'Brown / L',
      price: 18500,
      available: true,
      options: ['Brown', 'L'],
      featured_image: { src: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?q=80&w=1000&auto=format&fit=crop' }
    },
    {
      id: 1004,
      title: 'Brown / XL',
      price: 18500,
      available: true,
      options: ['Brown', 'XL'],
      featured_image: { src: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?q=80&w=1000&auto=format&fit=crop' }
    },
    {
      id: 1005,
      title: 'Black / S',
      price: 18500,
      available: true,
      options: ['Black', 'S'],
      featured_image: { src: 'https://images.unsplash.com/photo-1520975916090-3105956dac38?q=80&w=1000&auto=format&fit=crop' }
    },
    {
      id: 1006,
      title: 'Black / M',
      price: 18500,
      available: true,
      options: ['Black', 'M'],
      featured_image: { src: 'https://images.unsplash.com/photo-1520975916090-3105956dac38?q=80&w=1000&auto=format&fit=crop' }
    },
    {
      id: 1007,
      title: 'Black / L',
      price: 18500,
      available: true,
      options: ['Black', 'L'],
      featured_image: { src: 'https://images.unsplash.com/photo-1520975916090-3105956dac38?q=80&w=1000&auto=format&fit=crop' }
    },
    {
      id: 1008,
      title: 'Black / XL',
      price: 18500,
      available: true,
      options: ['Black', 'XL'],
      featured_image: { src: 'https://images.unsplash.com/photo-1520975916090-3105956dac38?q=80&w=1000&auto=format&fit=crop' }
    },
    {
      id: 1009,
      title: 'Tan / S',
      price: 18500,
      available: true,
      options: ['Tan', 'S'],
      featured_image: { src: 'https://images.unsplash.com/photo-1544441893-675973e31985?q=80&w=1000&auto=format&fit=crop' }
    },
    {
      id: 1010,
      title: 'Tan / M',
      price: 18500,
      available: true,
      options: ['Tan', 'M'],
      featured_image: { src: 'https://images.unsplash.com/photo-1544441893-675973e31985?q=80&w=1000&auto=format&fit=crop' }
    },
    {
      id: 1011,
      title: 'Tan / L',
      price: 18500,
      available: false,
      options: ['Tan', 'L'],
      featured_image: { src: 'https://images.unsplash.com/photo-1544441893-675973e31985?q=80&w=1000&auto=format&fit=crop' }
    },
    {
      id: 1012,
      title: 'Tan / XL',
      price: 18500,
      available: true,
      options: ['Tan', 'XL'],
      featured_image: { src: 'https://images.unsplash.com/photo-1544441893-675973e31985?q=80&w=1000&auto=format&fit=crop' }
    }
  ],
  url: '/products/vincent-leather-jacket'
};

class ProductQuickView extends HTMLElement {
  constructor() {
    super();
    this.productCache = new Map();
    this.currentProduct = null;
    this.currentVariant = null;
    this.selectedOptions = [];
    this.currentImageIndex = 0;
  }

  connectedCallback() {
    this.dialog = this.querySelector('.quick-view__dialog');
    this.content = this.querySelector('[data-content]');
    this.backdrop = this.querySelector('.quick-view__backdrop');
    this.closeBtn = this.querySelector('.quick-view__close');

    this.addEventListener('click', (e) => {
      if (e.target.hasAttribute('data-close') || e.target.closest('[data-close]')) {
        this.close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.hasAttribute('hidden')) {
        this.close();
      }
    });
  }

  formatPrice(cents) {
    // The theme's own formatter (shop money format), exposed by cart.js.
    if (window.Atelier?.formatMoney) return window.Atelier.formatMoney(cents);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      const format = (window.Atelier && window.Atelier.moneyFormat) || '${{amount}}';
      return window.Shopify.formatMoney(cents, format);
    }
    const val = (cents / 100.0).toFixed(2);
    return '£' + val;
  }

  updateCartCount(count) {
    const num = Number(count);
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = num > 0 || el.hasAttribute('data-show-zero') ? num : '';
    });
    document.querySelectorAll('[data-cart-count-label]').forEach((el) => {
      el.textContent = `${num} items`;
    });
    if (window.Atelier?.Cart?.setCount) {
      window.Atelier.Cart.setCount(num);
    }
    if (window.Cart?.setCount) {
      window.Cart.setCount(num);
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: num } }));
  }

  async open(handle) {
    if (!handle) handle = 'vincent-leather-jacket';
    this.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    // Show loading spinner
    if (this.content) {
      this.content.innerHTML = `
        <div class="quick-view__loading">
          <div class="quick-view__spinner"></div>
        </div>
      `;
    }

    if (handle === 'vincent-leather-jacket' || handle === 'demo-vincent-leather-jacket') {
      setTimeout(() => this.render(DEMO_PRODUCT), 150);
      return;
    }

    try {
      let product = this.productCache.get(handle);
      if (!product) {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error('Product fetch failed: ' + handle);
        product = await res.json();
        this.productCache.set(handle, product);
      }
      this.render(product);
    } catch (err) {
      console.warn('Quick view falling back to demo product:', err);
      this.render(DEMO_PRODUCT);
    }
  }

  close() {
    this.setAttribute('hidden', '');
    document.body.style.overflow = '';
    this.currentProduct = null;
    if (this.returnToCart) {
      this.returnToCart = false;
      // Deferred: the click / Escape that closed this popup is still bubbling, and the island
      // header would read it as an outside click and shut the cart again straight away.
      setTimeout(() => window.Atelier?.Cart?.open(), 0);
    }
  }

  render(product) {
    this.currentProduct = product;
    this.currentImageIndex = 0;

    let variant = product.variants.find((v) => v.available) || product.variants[0];
    this.currentVariant = variant;
    this.selectedOptions = variant ? [...variant.options] : [];

    const images = (product.images && product.images.length > 0)
      ? product.images
      : [product.featured_image || ''];

    const hasMultipleImages = images.length > 1;

    let galleryDotsHtml = '';
    if (hasMultipleImages) {
      galleryDotsHtml = `
        <div class="quick-view__dots" data-dots>
          ${images.slice(0, 7).map((_, idx) => `
            <button type="button" class="quick-view__dot${idx === 0 ? ' is-active' : ''}" data-image-index="${idx}" aria-label="Go to slide ${idx + 1}"></button>
          `).join('')}
        </div>
      `;
    }

    let optionsHtml = '';
    product.options.forEach((opt, optIdx) => {
      const isColor = /color|colour|màu/i.test(opt.name);
      const selectedVal = this.selectedOptions[optIdx] || opt.values[0];

      if (isColor) {
        const swatchesHtml = opt.values.map((val) => {
          const sampleVariant = product.variants.find((v) => v.options[optIdx] === val);
          const thumb = sampleVariant && sampleVariant.featured_image
            ? (typeof sampleVariant.featured_image === 'string' ? sampleVariant.featured_image : sampleVariant.featured_image.src)
            : null;
          const isActive = selectedVal === val;

          return `
            <button
              type="button"
              class="quick-view__swatch${isActive ? ' is-active' : ''}"
              data-option-index="${optIdx}"
              data-option-value="${val.replace(/"/g, '&quot;')}"
              title="${val.replace(/"/g, '&quot;')}"
            >
              ${thumb
                ? `<img src="${thumb}" alt="${val}" width="40" height="40" loading="lazy">`
                : `<span class="quick-view__swatch-color" style="background-color: ${val.toLowerCase()};"></span>`
              }
            </button>
          `;
        }).join('');

        optionsHtml += `
          <div class="quick-view__option-group" data-option-group="${optIdx}">
            <div class="quick-view__option-label">
              ${opt.name}: <span data-option-val-label>${selectedVal}</span>
            </div>
            <div class="quick-view__swatches">
              ${swatchesHtml}
            </div>
          </div>
        `;
      } else {
        const sizePillsHtml = opt.values.map((val) => {
          const isActive = selectedVal === val;
          const canBuy = product.variants.some((v) => {
            return v.options[optIdx] === val && v.available;
          });

          return `
            <button
              type="button"
              class="quick-view__size-btn${isActive ? ' is-active' : ''}"
              data-option-index="${optIdx}"
              data-option-value="${val.replace(/"/g, '&quot;')}"
              ${!canBuy ? 'data-unavailable' : ''}
            >
              ${val}
            </button>
          `;
        }).join('');

        optionsHtml += `
          <div class="quick-view__option-group" data-option-group="${optIdx}">
            <div class="quick-view__option-label">
              ${opt.name}
            </div>
            <div class="quick-view__sizes">
              ${sizePillsHtml}
            </div>
          </div>
        `;
      }
    });

    const isAvailable = variant && variant.available;

    this.content.innerHTML = `
      <div class="quick-view__grid">
        <div class="quick-view__gallery">
          <div class="quick-view__image-wrapper">
            <img
              class="quick-view__image"
              src="${images[0]}"
              alt="${product.title.replace(/"/g, '&quot;')}"
              data-main-img
              width="600"
              height="800"
            >
          </div>
          ${galleryDotsHtml}
        </div>

        <div class="quick-view__info">
          <h2 class="quick-view__title">${product.title}</h2>
          <div class="quick-view__price" data-price-wrap>
            ${this.formatPrice(variant ? variant.price : product.price)}
          </div>

          <div class="quick-view__options">
            ${optionsHtml}
          </div>

          <div class="quick-view__quantity-wrapper">
            <div class="quick-view__quantity">
              <button type="button" class="quick-view__qty-btn" data-qty-dec aria-label="Decrease quantity">&minus;</button>
              <input type="number" class="quick-view__qty-input" data-qty-input value="1" min="1" max="99" aria-label="Quantity">
              <button type="button" class="quick-view__qty-btn" data-qty-inc aria-label="Increase quantity">&#43;</button>
            </div>
          </div>

          <div class="quick-view__actions">
            <button
              type="button"
              class="quick-view__btn-add"
              data-btn-add
              ${!isAvailable ? 'disabled' : ''}
            >
              ${isAvailable ? 'ADD TO CART' : 'SOLD OUT'}
            </button>
            <button
              type="button"
              class="quick-view__btn-buy"
              data-btn-buy
              ${!isAvailable ? 'disabled' : ''}
            >
              BUY IT NOW
            </button>
          </div>

          <a href="${product.url}" class="quick-view__more-details">More details</a>
        </div>
      </div>
    `;

    this.bindEvents(images);
  }

  bindEvents(images) {
    const dots = this.querySelectorAll('[data-image-index]');
    const mainImg = this.querySelector('[data-main-img]');

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.imageIndex, 10);
        if (images[idx] && mainImg) {
          mainImg.style.opacity = '0';
          setTimeout(() => {
            mainImg.src = images[idx];
            mainImg.style.opacity = '1';
          }, 150);
          dots.forEach((d) => d.classList.remove('is-active'));
          dot.classList.add('is-active');
          this.currentImageIndex = idx;
        }
      });
    });

    const optionBtns = this.querySelectorAll('[data-option-index]');
    optionBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const optIdx = parseInt(btn.dataset.optionIndex, 10);
        const val = btn.dataset.optionValue;

        this.selectedOptions[optIdx] = val;

        const group = btn.closest('[data-option-group]');
        if (group) {
          group.querySelectorAll('[data-option-index]').forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');

          const labelVal = group.querySelector('[data-option-val-label]');
          if (labelVal) labelVal.textContent = val;
        }

        const match = this.currentProduct.variants.find((v) =>
          v.options.every((opt, i) => opt === this.selectedOptions[i])
        );

        this.currentVariant = match;

        const priceEl = this.querySelector('[data-price-wrap]');
        if (priceEl && match) {
          priceEl.innerHTML = this.formatPrice(match.price);
        }

        if (match && match.featured_image && mainImg) {
          const imgSrc = typeof match.featured_image === 'string' ? match.featured_image : match.featured_image.src;
          const imgIdx = images.indexOf(imgSrc);
          mainImg.src = imgSrc;
          if (imgIdx !== -1 && dots[imgIdx]) {
            dots.forEach((d) => d.classList.remove('is-active'));
            dots[imgIdx].classList.add('is-active');
          }
        }

        const addBtn = this.querySelector('[data-btn-add]');
        const buyBtn = this.querySelector('[data-btn-buy]');
        if (match && match.available) {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = 'ADD TO CART';
          }
          if (buyBtn) buyBtn.disabled = false;
        } else {
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.textContent = 'SOLD OUT';
          }
          if (buyBtn) buyBtn.disabled = true;
        }
      });
    });

    const qtyInput = this.querySelector('[data-qty-input]');
    const decBtn = this.querySelector('[data-qty-dec]');
    const incBtn = this.querySelector('[data-qty-inc]');

    if (decBtn && qtyInput) {
      decBtn.addEventListener('click', () => {
        let val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
    }

    if (incBtn && qtyInput) {
      incBtn.addEventListener('click', () => {
        let val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    const addBtn = this.querySelector('[data-btn-add]');
    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        if (!this.currentVariant || !this.currentVariant.available) return;

        const qty = parseInt(qtyInput?.value, 10) || 1;
        addBtn.disabled = true;
        const origText = addBtn.textContent;
        addBtn.textContent = 'ADDING...';

        const showAddedFeedback = () => {
          addBtn.textContent = 'ADDED';
          addBtn.classList.add('is-added');

          setTimeout(() => {
            addBtn.textContent = origText;
            addBtn.classList.remove('is-added');
            addBtn.disabled = false;
          }, 2000);
        };

        const themeCart = window.Atelier?.Cart;
        const isDemo = this.currentProduct === DEMO_PRODUCT;

        try {
          const formData = new FormData();
          formData.append('id', this.currentVariant.id);
          formData.append('quantity', qty);

          if (themeCart) {
            // Through the theme's cart, so the drawer and the header count re-render with the new line.
            await themeCart.add(formData);
            if (themeCart.open()) {
              this.returnToCart = false;
              this.close();
              return;
            }
            showAddedFeedback();
            return;
          }

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' },
          });

          if (!res.ok) throw new Error('Add to cart failed');

          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          this.updateCartCount(cart.item_count);
          showAddedFeedback();
        } catch (err) {
          if (themeCart && !isDemo) {
            // A real product that Shopify refused (sold out, quantity limit): say so, don't fake it.
            addBtn.textContent = err.message || origText;
            setTimeout(() => {
              addBtn.textContent = origText;
              addBtn.disabled = false;
            }, 3000);
            return;
          }
          console.warn('Add to cart fallback:', err);
          // If demo item or offline, update count visually on header
          let currentCount = 0;
          const firstCountEl = document.querySelector('[data-cart-count]');
          if (firstCountEl && firstCountEl.textContent.trim()) {
            currentCount = parseInt(firstCountEl.textContent.trim(), 10) || 0;
          }
          this.updateCartCount(currentCount + qty);
          showAddedFeedback();
        }
      });
    }

    const buyBtn = this.querySelector('[data-btn-buy]');
    if (buyBtn) {
      buyBtn.addEventListener('click', async () => {
        if (!this.currentVariant || !this.currentVariant.available) return;

        const qty = parseInt(qtyInput?.value, 10) || 1;
        buyBtn.disabled = true;
        buyBtn.textContent = 'PROCESSING...';

        try {
          const formData = new FormData();
          formData.append('id', this.currentVariant.id);
          formData.append('quantity', qty);

          await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' },
          });

          window.location.href = '/checkout';
        } catch (err) {
          console.error(err);
          window.location.href = `/cart/${this.currentVariant.id}:${qty}`;
        }
      });
    }
  }
}

if (!customElements.get('product-quick-view')) {
  customElements.define('product-quick-view', ProductQuickView);
}

// Global click delegation for opening Quick View with capture phase
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-quick-view-handle]');
  if (!trigger) return;

  // If block itself is configured as 'link', allow normal navigation
  if (trigger.dataset.clickAction === 'link') return;

  // If parent section is configured as 'link', allow normal navigation
  const sectionEl = trigger.closest('[data-title-action]');
  if (sectionEl && sectionEl.dataset.titleAction === 'link') return;

  e.preventDefault();
  e.stopPropagation();

  const handle = trigger.dataset.quickViewHandle || 'vincent-leather-jacket';
  const modal = document.querySelector('product-quick-view');
  if (modal) {
    // Opened from the cart: on mobile the drawer is a modal dialog and would sit on top of this
    // popup, so it steps aside and comes back when the popup closes.
    const cart = trigger.closest('#cart-drawer');
    modal.returnToCart = Boolean(cart);
    if (cart?.open) cart.close();
    modal.open(handle);
  }
}, true);
